export default {
  params: ['target'],
  validate: (value, { target }) => {
    return {
      required: true,
      valid: value === target,
    };
  },
  message: (fieldName, { _value_: v, target }) => {
    const defaultMsg = 'Please confirm your new password.';
    if (!v) return defaultMsg;
    if (v !== target) return 'Password confirmation does not match.';
    return defaultMsg;
  },
  computesRequired: true,
};
